<template>
  <div v-if="nicks.length > 1" class="card mt-3">
    <header class="card-header">
      <p class="card-header-title has-background-info-light has-text-info-dark">
        Promjene imena
      </p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div v-for="nick in nicks" :key="nick.date" class="column">
          <p>Ime: {{ nick.name }}</p>
          <p>Dan: {{ nick.updated | moment('calendar') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { useRouter } from '@u3u/vue-hooks';

export default {
  setup() {
    const { route } = useRouter();
    const apiHost = process.env.VUE_APP_API_HOST;
    const nickURL = '/player/nicks/';
    const { id } = route.value.params;

    const nicks = ref([]);

    const API_URL = apiHost;

    async function getNick() {
      const response = await fetch(API_URL + nickURL + id);
      const json = await response.json();
      nicks.value = json;
    }

    getNick();

    return {
      nicks,
    };
  },
};
</script>

<style></style>
